import { defineComponent as _defineComponent } from 'vue'
import { onMounted, Ref, ref } from "vue";
import Examination from "@/interfaces/examination.interface";
import useHttpRequest from "@/composables/use-http-request";
import CourseUnit from "@/interfaces/course-unit.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'available-examinations-component',
  setup(__props) {

const isFetching = ref(true);
const isError = ref(false);
const fetchingExamID = ref(null);
const examinations: Ref<
  {
    course_unit: CourseUnit;
    examination: Examination;
  }[]
> = ref([]);

const forMarksOnly = (examination: Examination) => {
  const submission = examination.student_examination_submissions?.[0];
  return !!submission && submission.for_marks_only;
};

const isMissedExam = (examination: Examination) => {
  const submission = examination.student_examination_submissions?.[0];
  return examination.is_exam_ended && !submission;
};

const examSubmitted = (examination: Examination) => {
  const submission = examination.student_examination_submissions?.[0];
  return !!submission && submission.submitted_at;
};

const neverCompleted = (examination: Examination) => {
  const submission = examination.student_examination_submissions?.[0];
  return !!submission && !submission.submitted_at;
};

const fetchAvailableExams = async () => {
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    examinations: {
      course_unit: CourseUnit;
      examination: Examination;
    }[];
  }>({
    method: "GET",
    url: "examinations/fetch-all-for-student",
    loadingProperty: isFetching,
    errorLoadingProperty: isError,
    showSuccessMessage: false,
  });

  if (!request) return;
  if (request.success && request.message == "STUDENT EXAMINATIONS RETRIEVED") {
    examinations.value = request.examinations;
  }
};

onMounted(() => {
  fetchAvailableExams();
});

return { __sfc: true,isFetching, isError, fetchingExamID, examinations, forMarksOnly, isMissedExam, examSubmitted, neverCompleted, fetchAvailableExams }
}

})